// Import ES6 Promise
import 'es6-promise/auto'

// Import System requirements
import Vue from 'vue'
import VueRouter from 'vue-router'
import es from 'vee-validate/dist/locale/es'
import VeeValidate, { Validator, ValidationProvider } from 'vee-validate'
import { sync } from 'vuex-router-sync'
import routes from './routes'
import store from './store'
import VueResource from 'vue-resource'
import VueSession from 'vue-session'

// Import Helpers for filters
import { domain, count, prettyDate, pluralize } from './filters'

// Import Views - Top level
import AppView from './components/App.vue'

// Import Install and register helper items
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)

Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VueSession)
// Vue.use(VeeValidate)
const config = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  errorBagName: 'errores', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'campos',
  inject: true,
  locale: 'es'
}

Vue.use(VeeValidate, config)
Vue.component('ValidationProvider', ValidationProvider)
Validator.localize('es', es)
// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  // Para el reestablecimiento de password
  let urlParams = new URLSearchParams(window.location.search)
  if (urlParams.has('e') && window.location.pathname === '/' && to.path === '/') {
    next({
      path: '/pswreestablecida',
      query: {email: urlParams.get('e')}
    })
  }
  if (to.matched.some(record => record.meta.requiresAuth) && (!router.app.$store.state.token || router.app.$store.state.token === 'null')) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    window.console.log('Not authenticated')
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
})

sync(store, router)

// Check local storage to handle refreshes
if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null'
  var localUser = JSON.parse(localUserString)

  if (localUser && store.state.user !== localUser) {
    store.commit('SET_USER', localUser)
    store.commit('SET_TOKEN', window.localStorage.getItem('token'))
  }
}

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  http: {
    emulateJSON: true,
    emulateHTTP: true
  },
  el: '#root',
  router: router,
  store: store,
  render: h => h(AppView)
})



// WEBPACK FOOTER //
// ./src/main.js